import { Stack } from '@mui/material'
import React from 'react'
import ChargingProfileList from './ChargingProfileLists/ChargingProfileList'

const ChargingProfileView = () => { 
  return (
    <Stack spacing={2}>
    <ChargingProfileList/>
    </Stack>
  )
}

export default ChargingProfileView